// extracted by mini-css-extract-plugin
export var attribution = "_9l-4";
export var authorName = "_9l-5";
export var quote = "_9l-3";
export var testimonial = "_9l-2";
export var trustedBy = "_9l-0";
export var trustedByLabel = "_9l-1";